var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"px-1 caption",class:_vm.status===0 ? '' : _vm.status===1 ? 'white--text' : _vm.status===2 ? 'white--text' : '',attrs:{"color":_vm.status===0 ? '' : _vm.status===1 ? 'warning' : _vm.status===2 ? 'error' : 'transparent',"rounded":""}},[_vm._v(" "+_vm._s(_vm.$tools.dateFormat(_vm.chat.info.updated, true))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }